import type { FC, ReactNode } from 'react';

interface ModalHeaderProps {
  title: ReactNode;
  right: ReactNode;
  rightClassName?: 'city' | 'page';
}

const ModalHeader: FC<ModalHeaderProps> = ({
  title,
  right,
  rightClassName = 'city'
}) => (
  <div className='header'>
    <span className='title'>{title}</span>
    <span className={rightClassName}>{right}</span>
  </div>
);

export default ModalHeader;
